import { cachedFetchCategoriesWithChildren } from "@/app/api/depict/categories.json/actions";
import type { FormattedDepictCategory } from "@/app/api/depict/categories.json/route";
import { DepictErrorMessage, DepictOptions } from "@/lib/depict/types";
import { Err, Ok } from "@frend-digital/utils/results";
import { FetchError } from "ofetch";
import { fetchRecommendations } from "./helpers";

export const getDepictCategoryBySlug = async (
  paramSlugs: string[] | undefined
) => {
  if (!paramSlugs) {
    console.log("No paramSlugs found");
    return null;
  }
  const data = await cachedFetchCategoriesWithChildren();

  if (!data as unknown as FormattedDepictCategory[]) {
    return null;
  }

  const findCategoryBySlug = (
    categories: FormattedDepictCategory[],
    slugs: string[],
    index: number = 0
  ): FormattedDepictCategory | undefined => {
    const category = categories.find(
      ({ slug, value }) => slug === slugs[index] || value === slugs[index]
    );
    if (!category || index === slugs.length - 1) {
      const mappedCategory = categories.find(({ slug }) => {
        return slug === slugs.join("-");
      });

      return category || mappedCategory;
    }
    return findCategoryBySlug(category.children || [], slugs, index + 1);
  };

  const category = findCategoryBySlug(data, paramSlugs);

  if (!category) {
    return null;
  }

  return category;
};

export async function depictRequest<T>(
  url: string,
  method: "GET" | "POST",
  body?: DepictOptions & { merchant: string }
): Promise<Ok<T> | Err<DepictErrorMessage>> {
  try {
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    return Ok<T>(await res.json());
  } catch (e) {
    if (e instanceof FetchError && e.response?.status === 422) {
      return Err<DepictErrorMessage>(e.response._data);
    }
    return Err<DepictErrorMessage>({
      detail: [
        {
          loc: ["unknown"],
          msg: (e as Error).message ?? "Unknown error",
          type: "unknown_error",
        },
      ],
    });
  }
}

export async function recommendations(
  merchant: string,
  options: DepictOptions
) {
  return fetchRecommendations({
    merchant,
    options: {
      ...options,
    },
  });
}
